// import axios from 'axios';
import TeacherService from '../../../service/TeacherService/TeacherService';

const teacherService = new TeacherService();

const state = {
  name: '',
  courses: [],
  profile: {},
};

const getters = {
  courses: state => state.courses,
};

const mutations = {
  set_courses(state, courses) {
    state.courses = courses;
  },

  set_profile(state, profile) {
    state.profile = profile;
  },
  set_name(state, name) {
    state.name = name;
  },
};

const actions = {
  getMyCourses({ commit }) {
    return new Promise((resolve, reject) => {
      teacherService
        .getMyCourses()
        .then(resp => {
          commit('set_courses', resp.data);
          resolve(resp.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getProfile({ commit }) {
    return new Promise((resolve, reject) => {
      teacherService
        .getProfile()
        .then(resp => {
          console.log(resp);
          commit('set_profile', resp.data.data);
          resolve(resp.data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getName({ commit }) {
    return new Promise((resolve, reject) => {
      teacherService
        .getProfile()
        .then(resp => {
          console.log(resp);
          commit('set_name', resp.data.data.slug);
          resolve(resp.data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
